import { Component, OnInit } from '@angular/core';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { DocumentModel } from 'src/app/shared/models/document.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { callbackAdjustCA } from 'src/app/shared/constants/adjust-callback';
import { BUSINESS_CONST } from '../../../shared/constants/business.constants';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { navCode } from 'src/app/shared/constants/channel.constants';
import { DaliService, IPageLoadModel } from '@dali/tagger-ng8';
import { PAGEVIEW as PAGEVIEW_FA,
  CHANNEL as CHANNEL_FA,
  COUNTRY as COUNTRY_FA,
  BUSINNESS as BUSINNESS_FA,
  ENVIRONMENT as ENVIRONMENT_FA,
  FAMILY as FAMILY_FA,
  SUBFAMILY as SUBFAMILY_FA,
  PRODUCT as PRODUCT_FA } from 'src/app/shared/constants/dali-fa-tc.constants';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';

@Component({
  selector: 'app-configuration-introduction',
  templateUrl: './configuration-introduction.component.html',
  styleUrls: ['./configuration-introduction.component.scss'],
})
export class ConfigurationIntroductionComponent implements OnInit {
  documentInfo: DocumentModel;
  optionsData: any;
  postLogin: boolean;
  transaction_id: any;
  product_type: string;
  constructor(
    private abreCuentasService: AbreCuentasService,
    private navigationService: NavigationService,
    private bioCatchService: BioCatchService,
    private headerService: HeaderService,
    private parametersService: ParametersService,
    public copyService: CopyService,
    private adjustEvent: AdjustEvent,
    private taggingService: TaggingService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private daliService: DaliService,
    private firmlyApprovedService: FirmlyApprovedService,
  ) {
    this.headerService.show(false, false, true);
  }

  /**
   * Summary Get Document Info
   */
  ngOnInit() {
    if (this.firmlyApprovedService.isFirmlyApproved() && this.abreCuentasService.getProductsSelects().length === 1) {
      this.sendConfigurationPageLoad();
    }
    this.initBioCatch();
    this.documentInfo = this.abreCuentasService.getDocumentInfo();
    this.product_type = this.abreCuentasService.getproductSelected().product_type;
    if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS) {
      const event = {
        eventToken: 'r7egef',
        callbackParams: callbackAdjustCA,
      };
      this.adjustEvent.adjustTrackEvent(event);
    }
  }
  /**
   * Summary next Step
   */
  next() {
    if (this.abreCuentasService.haveLoan) {
      this.loanNavigation();
    } else {
      this.regularNavigation();
    }
  }

  loanNavigation() {
    this.abreCuentasService.getProspectResponse().client ? this.loanNavigationCE() : this.loanNavigationCN();
  }

  loanNavigationCE() {
    if (this.abreCuentasService.getRequestLoanSelected().elementId === '02' && this.abreCuentasService.getRequestEntity() !== 1) {
      this.navigationService.nextStep(navCode[203]);
    } else if (this.abreCuentasService.getWasDeleteLoan()) {
      this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
    } else {
      this.navigationService.nextStep(navCode[202]);
    }
  }

  loanNavigationCN() {
    this.navigationService.nextStep(navCode[204]);
  }

  regularNavigation() {
    if (this.abreCuentasService.getProspectResponse().client) {
      this.optionsData = this.parametersService.getSetting(OpEnum.AGENCY_LIST);
      let code_agency = this.abreCuentasService.getCustomerData().basic.originator_branch;
      code_agency = code_agency.length === 1 ? '00' + code_agency : code_agency.length === 2 ? '0' + code_agency :
        code_agency;
      let agency_word = this.optionsData.filter(agency => agency.agency_code === code_agency);
      this.abreCuentasService.setAgencySelected(agency_word[0]);
    }
    if (this.abreCuentasService.viewOptionMultiProduct) {
      this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
    } else {
      if (this.abreCuentasService.getClientProduct()
        && this.abreCuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING) {
        return this.navigationService.nextStep('201');
      }
      this.navigationService.nextStep();
    }
  }

  initBioCatch() {
    const postLogin = this.abreCuentasService.getPostlogin();
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    this.bioCatchService.changeContext(StepBiocatchEnum.configuracion, product, !postLogin);
  }

  /* ------------- Taggeo ------------- */

  /* ------------ Taggeo - PageLoad ------------ */
  sendConfigurationPageLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const productsType = {
      ORD: 'LD',
      TCR: 'TC',
    };
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA.pv7pageName.path,
        value: `${isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking}:${COUNTRY_FA.co}:${BUSINNESS_FA.pf}:${ENVIRONMENT_FA.loggeado}:${FAMILY_FA.services}:${SUBFAMILY_FA.request}:${PRODUCT_FA.request}:${PAGEVIEW_FA.pv7pageName.value}`,
      },
      {
        path: PAGEVIEW_FA.pv7pageFamily.path,
        value: PAGEVIEW_FA.pv7pageFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv7subFamily.path,
        value: PAGEVIEW_FA.pv7subFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv7pageAction.path,
        value: PAGEVIEW_FA.pv7pageAction.value,
      },
      {
        path: PAGEVIEW_FA.pv7pageid.path,
        value: ConfigurationIntroductionComponent.name,
      },
      {
        path: PAGEVIEW_FA.pv7transactionName.path,
        value: `${PAGEVIEW_FA.pv7transactionName.value.slice(0, -2)}${this.taggingService.getProductFlow()}`,
      },
      {
        path: PAGEVIEW_FA.pv7transactionTransactionStep.path,
        value: PAGEVIEW_FA.pv7transactionTransactionStep.value,
      },
    ];
    this.taggingService.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }
}
